// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-picker/style/index.less
// module id = 179
// module chunks = 0